import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Analyzer, Snapshot } from 'types';

const removeCrosspolSnapshots = (snapshots: Snapshot[]) => {
  const crosspolSnapshotIds = snapshots?.map(
    (snapshot) => snapshot.crosspol_snapshot_id
  );
  return snapshots.filter(
    (snapshot) => !crosspolSnapshotIds.includes(snapshot.id)
  );
};

export const getSnapshots = async ({
  analyzerId,
}: {
  analyzerId: number;
}): Promise<Snapshot[]> => {
  const { data }: { data: Analyzer } = await axios.get(
    `/api/analyzers/${analyzerId}`
  );
  const { snapshots } = data;
  return snapshots as Snapshot[];
};

type QueryFnType = typeof getSnapshots;

type UseSnapshotsOptions = {
  analyzerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useSnapshots = ({ analyzerId, config }: UseSnapshotsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['snapshots', analyzerId],
    queryFn: () => getSnapshots({ analyzerId }),
    select: (data) => removeCrosspolSnapshots(data),
    ...config,
  });
};
